import React, { useMemo } from 'react';
import toast from 'react-hot-toast';
import PropTypes from 'prop-types';
import CustomToast from './CustomToast';

export const Type = Object.freeze({
  Error: 'error',
  Success: 'success',
});

const Toast = ({ id, text, type, icon, position, className }) => {
  const defaultOptions = useMemo(
    () => ({
      id,
      duration: 4000,
      position: position || 'bottom-center',
    }),
    [id, position],
  );

  const customOptions = useMemo(
    () => ({
      className: className || '',
      icon: icon || null,
      iconTheme: {
        primary: '#000',
        secondary: '#fff',
      },
      ariaProps: {
        role: 'status',
        'aria-live': 'polite',
      },
    }),
    [className, icon],
  );

  if (type === Type.Success || type === Type.Error) {
    toast.custom(
      (t) => (
        <CustomToast text={text} type={type} visible={t.visible} id={t.id} />
      ),
      defaultOptions,
    );
  } else {
    toast(text, customOptions);
  }
  return null;
};

Toast.propTypes = {
  id: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  type: PropTypes.oneOf(Object.values(Type)),
  icon: PropTypes.string,
  position: PropTypes.string,
  className: PropTypes.string,
};

Toast.defaultProps = {
  type: null,
  icon: '',
  position: '',
  className: '',
};

export default Toast;
